/* eslint-disable max-len */
/* eslint-disable new-cap */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  DatePicker,
  Typography,
} from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  RedoOutlined,
  CopyOutlined,
} from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import moment from 'moment';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import Select from 'components/Select';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { getEstadosGlobales, getPeriodicidadesDePagos } from 'api/catalogos/index';
import ModalDelete from 'components/ModalDelete';
import {
  getTarifasISR,
  postTarifaISR,
  patchTarifaISR,
  deleteTarifaISR,
  getTarifaISR,
  clonarTarifaISR,
} from 'api/estructuraOrganizacional/tarifasISR';
import { getPermisos } from 'api/usuarios';
import { useDispatch, useSelector } from 'react-redux';
import { selectPermisos } from 'store/catalogos';
import { checkToken } from 'api/utils';
import { getSubsidios } from 'api/estructuraOrganizacional/subsidio';
import {
  ESTATUS_ACTIVO,
  ESTATUS_CANCELADO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { DATE_FRONTEND_FORMAT } from 'utils/normalizers';
import TarifaISRDetalle from './TarifaISRDetalle';
import TarifaISRTipoEmpleado from './TarifaISRTipoEmpleado';
import TarifaISRtiposDeNomina, { getPermissionTarifaISRtiposDeNomina } from './TarifaISRtiposDeNomina';

export const tarifaPermission = {
  permissionModel: 'tarifaisr',
  catalogsModels: ['permission'],
};

const { Text } = Typography;

/* eslint-disable react/prop-types */
const TarifaISR = ({ permission }) => {
  const dispatch = useDispatch();
  const permisos = useSelector(selectPermisos);
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [estados, setEstados] = useState([]);
  const [subsidios, setSubsidios] = useState([]);
  const [confirmationVisibleAutorizar, setConfirmationVisibleAutorizar] = useState(false);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [confirmationVisibleCancelar, setConfirmationVisibleCancelar] = useState(false);
  const [confirmationVisibleReactivar, setConfirmationVisibleReactivar] = useState(false);
  const [confirmationVisibleClonar, setConfirmationVisibleClonar] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estatusCancelado, setEstatusCancelado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [estadoFinal, setEstadoFinal] = useState();
  const [estatus, setEstatus] = useState();
  const [esTarifaAnual, setEsTarifaAnual] = useState(false);

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getTarifasISR();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
        _periodosFiscales,
        _periodos,
        _estados,
        _subsidios,
      ] = await Promise.all([
        getTarifasISR(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodicidadesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
        getEstadosGlobales(),
        getSubsidios({ estados_globales: ESTATUS_AUTORIZADO }),
        getPermisos(dispatch, permisos),
      ]);
      if (mounted) {
        setPeriodosFiscales(_periodosFiscales);
        setPeriodos(_periodos);
        setData(formatReceived(_data));
        setEstados(_estados);
        setSubsidios(_subsidios);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setEstatusCancelado(false);
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const tarifa = await getTarifaISR(match.id);
    if (tarifa?.estados_globales === ESTATUS_ACTIVO
      || tarifa?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
        || estado?.id === ESTATUS_ACTIVO));
    }
    if (tarifa?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (tarifa?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    if (tarifa?.estados_globales === ESTATUS_CANCELADO) {
      setEstadosFiltered(estados?.filter((estado) => estado?.id === ESTATUS_CANCELADO));
      setEstatusCancelado(true);
    }
    setEsTarifaAnual(tarifa?.es_tarifa_anual);
    setTimeout(() => {
      if (tarifa) {
        form.resetFields();
        formDatos.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(tarifa));
          formDatos.setFieldsValue(formatReceived(tarifa));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const saved = await (key ? patchTarifaISR(key, values) : postTarifaISR(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteTarifaISR(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
  };

  const estatusFuncion = (val) => {
    if (val === ESTATUS_ACTIVO || val === ESTATUS_INACTIVO) {
      setEstatus(true);
      setEstadoFinal(val);
    } else {
      setEstatus(false);
      setEstadoFinal(val);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    estatusFuncion(record.estados_globales);
    setTimeout(() => {
      form.setFieldsValue(record);
    });
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setEstadosFiltered(estados);
    setVisible(true);
  };

  const onClickDelete = () => setVisibleAlert(true);

  const rules = {
    required: [{ required: true }],
    startDate: [
      { required: true },
      {
        validator: async () => {
          const { fecha_del, al } = form.getFieldsValue();
          if (fecha_del && al
            && fecha_del.diff(al, 'days') >= 0) {
            throw new Error('Este campo debe ser menor que la Fecha Final');
          }
        },
      },
    ],
    endDate: [
      { required: true },
      {
        validator: async () => {
          const { fecha_del, al } = form.getFieldsValue();
          if (fecha_del && al
            && al.diff(fecha_del, 'days') <= 0) {
            throw new Error('Este campo debe ser mayor que la Fecha Inicial');
          }
        },
      },
    ],
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        ...formDatos.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchTarifaISR(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisibleAutorizar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede cancelar una nómina ya cancelada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        ...formDatos.getFieldValue(),
        estados_globales: ESTATUS_CANCELADO,
      };
      const res = await patchTarifaISR(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisibleCancelar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };

  const handleOnFinishConfirmationReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede reactivar una Tarifa de ISR Activa');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        ...formDatos.getFieldValue(),
        estados_globales: ESTATUS_ACTIVO,
      };
      const res = await patchTarifaISR(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisibleReactivar(false);
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationClonar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        setConfirmationVisibleClonar(false);
        return;
      }
      const clonada = await clonarTarifaISR(key);
      if (clonada) {
        onCancel();
        await fetchData();
        setConfirmationVisibleClonar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Año',
      dataIndex: 'ejercicio',
      key: 'ejercicio',
      render: (val) => periodosFiscales.find((e) => e.id === val)?.periodo,
    },
    {
      titleText: 'Periodicidad de Pago',
      dataIndex: 'periodicidad_de_pago',
      key: 'periodicidad_de_pago',
      render: (val) => periodos.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_del',
      key: 'fecha_del',
      render: (val) => val?.format(DATE_FRONTEND_FORMAT),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'al',
      key: 'al',
      render: (val) => val?.format(DATE_FRONTEND_FORMAT),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      render: (val) => estados?.find((estado) => estado?.id === val)?.descripcion,
    },
  ];

  const handleContentPrint = () => {
    const fechaInicial = new Date(form.getFieldValue('fecha_del'));
    const fechaFinal = new Date(form.getFieldValue('al'));
    return `Tarifa de ISR del: ${fechaInicial.toLocaleDateString()} al: ${fechaFinal.toLocaleDateString()}`;
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit,
              onClickDelete,
            }}
            disableDelete={
              estatus === false
            }
            customActions={[
              {
                onClick: () => setConfirmationVisibleAutorizar(true),
                permission: { model: 'tarifaisr', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
              {
                permission: { model: 'tarifaisr', action: 'cancelar' },
                onClick: () => setConfirmationVisibleCancelar(true),
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabledBySelection: false,
                className: 'cancel',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO,
              },
              {
                permission: { model: 'tarifaisr', action: 'reactivar' },
                onClick: () => setConfirmationVisibleReactivar(true),
                text: 'Reactivar',
                icon: <RedoOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_ACTIVO,
              },
              {
                permission: { model: 'tarifaisr', action: 'clonar' },
                onClick: () => setConfirmationVisibleClonar(true),
                text: 'Clonar',
                icon: <CopyOutlined />,
                disabledBySelection: false,
                disabled: !selectedRowKeys?.length,
              },
            ]}
            permission={permission}
            allowExportPDF={false}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Tarifa de ISR`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                disableOnFinish={estatusAutorizado === true || estatusCancelado === true || estatusInactivo === true}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={() => onFinish()}
              scrollToFirstError
              initialValues={{
                fecha_del: moment().startOf('year'),
                requiere_tarifa_subsidio: false,
              }}
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="ejercicio"
                    label="Año"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      dataSource={periodosFiscales}
                      disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_del"
                    label="Fecha Inicial"
                    rules={rules.startDate}
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="al"
                    label="Fecha Final"
                    rules={rules.endDate}
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodicidad_de_pago"
                    rules={rules.required}
                    label="Periodicidad de Pago"
                    hasFeedback
                  >
                    <Select
                      dataSource={periodos}
                      disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="default_calculo_nomina"
                    label="Es la Tarifa Mensual"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Select
                      trueFalse
                      disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="calcular_con_periodos_en_mes"
                    label="Cálculo Mensualizado"
                    hasFeedback
                    tooltip="El cálculo de ISR de cada periodo de nómina, se realiza mensualizando las percepciones previamente conocidas y recurrentes, aplicando la Tarifa de ISR mensual"
                    rules={rules.required}
                  >
                    <Select
                      trueFalse
                      disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="es_tarifa_anual"
                    label="Es la Tarifa Anual"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Select
                      trueFalse
                      disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="requiere_tarifa_subsidio"
                    label="Requiere Tarifa de Subsidio"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Select
                      trueFalse
                      disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                      onChange={(value) => {
                        if (!value) {
                          form.setFieldsValue({ tarifa_subsidio: null });
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => prevValues.requiere_tarifa_subsidio !== currentValues.requiere_tarifa_subsidio}
                  >
                    {({ getFieldValue }) => (
                      <Form.Item
                        name="tarifa_subsidio"
                        label="Tarifa de Subsidio Aplicable"
                        hasFeedback
                        // El campo solo es requerido si se seleccionó "SI"
                        rules={getFieldValue('requiere_tarifa_subsidio') ? rules.required : []}
                      >
                        <Select
                          allowClear
                          dataSource={subsidios}
                          render={(val) => {
                            const ejercicio = periodosFiscales.find((pf) => pf?.id === val?.ejercicio)?.descripcion;
                            const periodicidadPago = periodos.find((p) => p?.id === val?.periodicidad_de_pago)?.descripcion;
                            return `${ejercicio} - ${periodicidadPago}`;
                          }}
                          // Se deshabilita si el campo booleano es false o si los estatus bloquean la edición
                          disabled={!getFieldValue('requiere_tarifa_subsidio') || estatusAutorizado || estatusInactivo || estatusCancelado}
                        />
                      </Form.Item>
                    )}
                  </Form.Item>
                </Col>
                {selectedRowKeys.length
                  ? (
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="estados_globales"
                        label="Estatus"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Select
                          dataSource={estadosFiltered}
                          disabled={!selectedRowKeys.length || estatusAutorizado || estatusInactivo
                            || estatusCancelado}
                          onChange={(val) => {
                            if (val === ESTATUS_INACTIVO) {
                              setConfirmationVisibleEstatus(true);
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  )
                  : (
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="estados_globales"
                        label="Estatus"
                        rules={rules.required}
                        hasFeedback
                        initialValue={1}
                      >
                        <Select
                          dataSource={estadosFiltered}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  )}
              </Row>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
            {selectedRowKeys.length ? (
              <>
                {!esTarifaAnual ? (
                  <>
                    <Text style={{ color: '#D88F4F' }}>Tipo de Nómina Empleado</Text>
                    <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                      <TarifaISRTipoEmpleado
                        permission={permission}
                        tarifaISR={selectedRowKeys[0]}
                        disableControls={estatusInactivo || estatusCancelado}
                        estatus={estadoFinal}
                      />
                    </div>
                  </>
                ) : null}
                <Text style={{ color: '#D88F4F' }}>Tipo de Nómina</Text>
                <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                  <TarifaISRtiposDeNomina
                    permission={permission}
                    selected={selectedRowKeys[0]}
                    estatusAutorizadoInactivo={estatusInactivo}
                  />
                </div>
                <Text style={{ color: '#D88F4F' }}>Tarifa ISR</Text>
                <TarifaISRDetalle
                  permission={permission}
                  selected={selectedRowKeys[0]}
                  disableControls={estatusAutorizado || estatusInactivo || estatusCancelado}
                  estatus={estadoFinal}
                />
              </>
            ) : null}
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={handleContentPrint()}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisibleAutorizar(false);
          }}
          open={confirmationVisibleAutorizar}
          title="Confirmación"
          contentTitle={`Autorizar la ${handleContentPrint()}`}
          ConfirmAutorize
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationCancelar}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisibleCancelar(false);
          }}
          open={confirmationVisibleCancelar}
          title="Confirmación"
          contentTitle={`Cancelar la ${handleContentPrint()}`}
          ConfirmCancel
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          title="Confirmación"
          contentTitle={`Inactivar la ${handleContentPrint()}`}
          ConfirmInactive
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => setConfirmationVisibleReactivar(false)}
          open={confirmationVisibleReactivar}
          title="Confirmación"
          contentTitle={`Reactivar la ${handleContentPrint()}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationClonar}
          onFinishText="Clonar"
          onFinishIcon={<CopyOutlined />}
          onCancel={() => setConfirmationVisibleClonar(false)}
          open={confirmationVisibleClonar}
          title="Confirmación"
          contentTitle={`Clonar la ${handleContentPrint()}, incluyendo su detalle`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default TarifaISR;
